/** Arabic – العربية (for UAE/Dubai and Arabic-speaking users). Missing keys fall back to English. */
export default {
  'nav.home': 'الرئيسية',
  'nav.seeDemo': 'مشاهدة العرض',
  'nav.howItWorks': 'كيف يعمل',
  'nav.pricing': 'الأسعار',
  'nav.aboutUs': 'من نحن',
  'nav.faqs': 'الأسئلة الشائعة',
  'nav.contact': 'اتصل بنا',
  'nav.blog': 'المدونة',
  'nav.logIn': 'تسجيل الدخول / إنشاء حساب',
  'nav.getStarted': 'ابدأ',
  'brand.primeDocumentSign': 'Prime Document Sign',
  'hero.priceBanner': 'ابتداءً من ٢ دولار فقط في الشهر!',
  'hero.oneAgreement': 'اتفاقية واحدة فقط؟ ٦ دولارات فقط مع ميزات بريميوم – بدون اشتراك.',
  'hero.subscriptionsOnly': '( الاشتراكات فقط )',
  'hero.couponBannerText': 'كود خصم 10% مدى الحياة لأول 1000 مستخدم!',
  'hero.couponSubscribedOnly': '(للمشتركين فقط)',
  'hero.couponCode': '25OFFNEWUSERS1000',
  'hero.bannerEyebrow': 'منصة التوقيع الإلكتروني · خطط من ٢ دولار/شهر',
  'hero.bannerHeadlinePrefix': 'وقّع',
  'hero.bannerHeadlineMid': 'فوراً',
  'hero.bannerHeadlineAccent': '',
  'hero.bannerCycleContracts': 'العقود',
  'hero.bannerCycleNDAs': 'اتفاقيات السرية',
  'hero.bannerCycleProposals': 'العروض',
  'hero.bannerCycleDocuments': 'المستندات',
  'hero.bannerDesc':
    'أنشئ اتفاقيات احترافية، أرسلها للتوقيع الإلكتروني، واستلم PDF موقّع ملزم قانوناً — في دقائق، من أي جهاز.',
  'hero.watchDemo': 'شاهد كيف يعمل',
  'hero.trustLocked': 'تشفير AES-256',
  'hero.trustNoCard': 'دون بطاقة',
  'hero.trustReady': 'جاهز خلال دقيقتين',
  'hero.landingShowMore': 'عرض المزيد',
  'hero.landingShowLess': 'عرض أقل',
  'hero.tagline': 'أسهل طريقة لإنشاء المستندات وتوقيعها وإرسالها — بلا التزام طويل',
  'hero.firebaseTopAria': 'الأمان والاستضافة (Google Firebase وGoogle Cloud)',
  'hero.topTrustListAria': 'الأمان، التسعير، التوقيع، التذكيرات والدعم',
  'hero.accDataSafeTitle': 'بياناتك آمنة معنا',
  'hero.accDataSafe1':
    'مدعوم بـ Google Firebase وGoogle Cloud — نفس البنية التي يثق بها ملايين التطبيقات',
  'hero.accDataSafe2':
    'بياناتك محمية بتشفير AES-256 مع مفاتيح تديرها Google',
  'hero.accDataSafe3':
    'مصادقة آمنة ومعالجة بيانات وفق معايير أمان Google الرائدة',
  'hero.accDataSafe4': 'لا نبيع ولا نشارك بياناتك — خصوصيتك محترمة دائماً',
  'hero.accDataSafe5Before': 'شفافية كاملة حول تخزين واستخدام بياناتك (راجع ',
  'hero.accDataSafe5After': ')',
  'hero.accPricingTitle': 'تسعير بسيط وبأسعار معقولة — بدون رسوم مخفية',
  'hero.accPricing1': 'أنشئ اتفاقيات احترافية في دقائق',
  'hero.accPricing2': 'خطط تبدأ من ٢ دولار شهرياً فقط',
  'hero.accPricing3': 'لا رسوم مخفية ولا مفاجآت',
  'hero.accPricing4': 'بدون التزام طويل — ألغِ في أي وقت',
  'hero.accPricing5': 'مثالي للمستقلين والناشئين والشركات الصغيرة',
  'hero.accPricing6': 'أرسل مستندك الأول مجاناً للبدء',
  'hero.accSigningTitle': 'توقيع مستندات سريع وسهل',
  'hero.accSigning1': 'اختر من أكثر من ٣٠ قالباً أو ارفع ملفك',
  'hero.accSigning2': 'أضف حقول التوقيع وخصّص في ثوانٍ',
  'hero.accSigning3': 'أرسل إلى عدة مستلمين دفعة واحدة',
  'hero.accSigning4': 'احفظ القوالب لإعادة الاستخدام',
  'hero.accSigning5': 'لا يحتاج الموقّعون حساباً — يوقّعون فوراً',
  'hero.accSigning6': 'معاينة مباشرة قبل الإرسال',
  'hero.accRemindersTitle': 'تذكيرات ذكية وتتبّع',
  'hero.accReminders1': 'متابعة تلقائية بعد ١ و٣ و٧ أيام',
  'hero.accReminders2': 'إشعار فوري عند فتح المستند أو توقيعه',
  'hero.accReminders3': 'تتبّع عملية التوقيع لحظياً',
  'hero.accReminders4': 'لا حاجة لمطاردة التوقيعات يدوياً',
  'hero.accAnywhereTitle': 'اعمل من أي مكان',
  'hero.accAnywhere1': 'الوصول للمستندات على الكمبيوتر أو الجوال',
  'hero.accAnywhere2': 'أرسل ووقّع من أي جهاز',
  'hero.accAnywhere3': 'مصمم للمرونة — في المكتب أو أثناء التنقّل',
  'hero.accSupportTitle': 'دعم موثوق',
  'hero.accSupport1': 'دعم عملاء مخصص مع ردود سريعة',
  'hero.accSupport2': 'نهدف للرد خلال ٢٤ ساعة',
  'hero.accSupport3': 'تحديثات مستمرة بناءً على ملاحظات المستخدمين',
  'hero.firebaseTrustPrivacyLink': 'سياسة الخصوصية',
  'hero.firebaseTrustFineprintAfter':
    ' توضح الاحتفاظ بالبيانات والوصول وحقوقك. لا نبيع بياناتك أبداً.',
  'hero.pill': 'أرسل توقيعات إلكترونية ملزمة قانونياً في ثوانٍ',
  'hero.headline': 'أبسط أداة توقيع إلكتروني للعملاء الحرين والفرق الصغيرة',
  'hero.ctaPrimary': 'إنشاء / رفع مستند وإرساله للتوقيع',
  'hero.ctaTrialSignup': 'جرّب الآن مع شهر مجاني',
  'hero.ctaFreeDocument': 'جرّب مستندًا مجانيًا الآن',
  'hero.ctaPrimaryNote': 'لا حاجة لبطاقة ائتمان أو بيانات دفع.',
  'hero.subscriptionTeaserBefore': 'الاشتراكات تبدأ من ',
  'hero.subscriptionTeaserAfter': ' فقط شهرياً!',
  'hero.createAccountTrialHeadline': 'سجّل الآن واحصل على تجربة مجانية لمدة شهر',
  'hero.createAccountPromoCopy': 'نسخ الرمز',
  'hero.createAccountPromoCopied': 'تم النسخ!',
  'hero.createAccountPromoCodeAria': 'رمز ترويجي: تجربة مجانية لمدة شهر',
  'hero.createAccountNote': 'استخدمه عند الدفع عند اختيار الخطة.',
  'hero.createAccountOfferLimit': '( العرض سارٍ لأول 1000 مستخدم فقط )',
  'hero.desc': 'يساعد الأفراد والفرق على إنشاء وإرسال ومتابعة الاتفاقيات بتجربة توقيع حديثة.',
  'hero.getStartedFree': 'ابدأ مجاناً',
  'hero.tryWithoutAccountButton': 'جرب بدون حساب',
  'hero.logInSignUp': 'تسجيل الدخول / إنشاء حساب',
  'hero.whyChooseUs': 'لماذا تختارنا؟',
  'hero.stepsTitle': 'إنشاء، توقيع، استلام',
  'hero.stepsSubtitle': 'ثلاث خطوات بسيطة لإنشاء المستندات وتوقيعها في دقائق.',
  'hero.step1Create': 'تحميل أو إنشاء المستند',
  'hero.step2Sign': 'إرساله للتوقيع',
  'hero.step3Receive': 'إشعار فوري عند التوقيع',
  'hero.benefit1': 'سهل الاستخدام – أرسل روابط التوقيع والإيميلات في ثوانٍ',
  'hero.benefit2': 'رفع PDF موجود أو استخراج النص وتحريره بالمحرر النصي الغني',
  'hero.benefit3': 'استخراج النص من PDF وتحريره',
  'hero.benefit4': 'إنشاء حقول وتخطيطات توقيع في ثوانٍ',
  'hero.benefit5': 'إرسال لعدة مستلمين في نفس الوقت',
  'hero.benefit6': 'لا حاجة للاشتراك – دفع لمرة واحدة',
  'hero.benefit7': 'انسخ الرابط وأرسله لأي شخص',
  'hero.benefit8': 'إنشاء وحفظ القوالب',
  'hero.benefit9': 'عرض أحداث البريد',
  'hero.benefit10': 'معاينة مباشرة وPDF جاهز للتدقيق',
  'hero.benefit11': 'قوالب غنية مع تحرير مرن',
  'hero.benefit12': 'المستلمون لا يحتاجون تسجيلاً',
  'hero.benefit13': 'يعمل على أي جهاز، من الحاسوب إلى الجوال',
  'how.simpleProcess': 'عملية بسيطة',
  'how.title': 'كيف يعمل',
  'how.subtitle': 'أنشئ وأرسل ووقّع في ثلاث خطوات.',
  'how.step1Title': 'إنشاء قالب',
  'how.step1Desc': 'استخراج ورفع PDF، محرر نصوص، حقول توقيع (تاريخ، الاسم الكامل، الشروط، التوقيع). احفظ كقالب واستخدمه متى شئت.',
  'how.step2Title': 'إرسال للمستلمين',
  'how.step2Desc': 'أرسل المستندات بالبريد مع روابط توقيع آمنة. أضف مستلمين متعددين، انسخ الروابط، وتتبع الفتح والإكمال.',
  'how.step3Title': 'استلام PDF الموقّع',
  'how.step3Desc': 'استلم PDF موقّع مع سجل تدقيق: الوقت، البريد، الهاتف، الموافقة. استلم بريد تأكيد عند الإكمال.',
  'pricing.compareHeadline': 'لماذا تدفع 19 دولاراً/شهراً للتوقيعات الإلكترونية؟',
  'pricing.comparePlatform': 'المنصة',
  'pricing.comparePrice': 'السعر',
  'pricing.compareUs': 'Prime Document Sign',
  'pricing.compareDocuSign': 'DocuSign',
  'pricing.compareDropboxSign': 'Dropbox Sign',
  'pricing.comparePandaDoc': 'PandaDoc',
  'pricing.comparePerMonth': '{price}/شهر',
  'pricing.compareBestValue': 'أفضل قيمة',
  'pricing.compareWhyPayLine1': 'أرسل توقيعات إلكترونية ملزمة قانوناً في ثوانٍ',
  'pricing.compareWhyPayLine2': 'أكثر من إرسال واحد؟ الاشتراكات تبدأ من ٢ دولار شهرياً',
  'pricing.compareBenefitSingle': 'إرسال مستندات فردية',
  'pricing.compareBenefitNoContract': 'بدون عقود باهظة',
  'pricing.compareBenefitPayWhenNeed': 'ادفع فقط عندما تحتاج',
  'pricing.compareBenefitTemplates': 'اختر من بين أكثر من 30 قالباً',
  'pricing.compareDisclaimer': 'أسعار المنافسين بناءً على خطط البداية المتاحة علناً وقد تختلف.',
  'trust.secureLinks': 'روابط توقيع فريدة وآمنة لكل مستند',
  'trust.auditTrail': 'سجل تدقيق كامل على كل توقيع (من، متى، IP)',
  'trust.verifiablePdfs': 'PDF موقّعة قابلة للتحقق يمكنك الاحتفاظ بها',
  'trust.footer': 'موثوق من العملاء الحرين والشركات الصغيرة حول العالم',
  'useCases.title': 'مثالي لـ ( قوالب جاهزة )',
  'useCases.freelancers': 'العملاء الحرين الذين يرسلون العقود',
  'useCases.agencies': 'الوكالات التي توقّع الاتفاقيات',
  'useCases.landlords': 'الملاك الذين يرسلون عقود الإيجار',
  'useCases.startups': 'الشركات الناشئة التي توقّع اتفاقيات السرية',
  'useCases.carBoat': 'بيع سيارة أو قارب بمستند قانوني',
  'useCases.consultants': 'المستشارون والمستقلون',
  'useCases.equipmentRental': 'تأجير المعدات باتفاق رسمي',
  'useCases.contractors': 'المقاولون المستقلون لإضفاء الطابع الرسمي على العمل',
  'useCases.website': 'اتفاقيات المشاريع الرقمية والويب',
  'pricing.title': 'الأسعار',
  'pricing.billAnnually': 'الفوترة السنوية',
  'pricing.billMonthly': 'الفوترة الشهرية',
  'pricing.getStarted': 'ابدأ',
  'pricing.mostPopular': 'الأكثر شعبية',
  'pricing.billedPerYear': '${amount}/سنة',
  'pricing.perMonth': '/شهر',
  'pricing.tierBasic': 'أساسي',
  'pricing.tierStandard': 'قياسي',
  'pricing.tierPremium': 'بريميوم',
  'pricing.descBasic': 'للاستخدام المتقطع.',
  'pricing.descStandard': 'للفرق المتنامية.',
  'pricing.descPremium': 'لمستخدمي القوة والاحتياجات المتقدمة.',
  'about.label': 'لماذا تختارنا',
  'about.title': 'من نحن',
  'about.subtitle': 'نجعل سير عمل التوقيع بسيطاً وسريعاً وآمناً لتركّز على عملك.',
  'about.speed': 'السرعة',
  'about.builtForSpeed': 'مصمم للسرعة',
  'about.builtForSpeedDesc': 'واجهة حديثة تتيح إنشاء وإرسال المستندات في دقائق. الموقّعون يكملون من أي جهاز بدون تنزيلات.',
  'about.security': 'الأمان',
  'about.dataSecurity': 'أمان البيانات',
  'about.dataSecurityTitle': 'مستضاف على Google Firebase وGoogle Cloud',
  'about.dataSecurityDesc': 'تُعالَج بيانات حسابك والمستندات والقوالب ونشاط التوقيع على Google Firebase وGoogle Cloud، وهي منصات مخصّصة للتطبيقات الإنتاجية التي تحتاج مصادقة وتخزيناً قويين. تُحمى الاتصالات ببروتوكول HTTPS (TLS) من طرف إلى طرف؛ وتُشفَّر البيانات المخزّنة بمفاتيح تُديرها Google (بما في ذلك AES-256). تستخدم مسارات تسجيل الدخول Firebase Authentication، وتساعد قواعد أمان Firestore على ضمان أن القراءات والكتابات تتوافق مع حسابك حتى تبقى مساحة عملك معزولة وليست قابلة للقراءة علناً من الإنترنت كله. يعمل المكدس على شبكة Google العالمية مع مراقبة وتحديثات وممارسات موثوقية كما في وثائق Google، ولا نبيع بياناتك الشخصية أو محتوى مستنداتك لوسطاء أو معلنين. لمعالجي البيانات الفرعيين وبرامج الامتثال وحقوقك، راجع سياسة الخصوصية.',
  'about.dataSecurityPrivacyCta': 'قراءة سياسة الخصوصية كاملة →',
  'about.privacyPill': 'الخصوصية',
  'about.privacyFocused': 'مراعاة الخصوصية',
  'about.privacyFocusedDesc': 'كل رابط توقيع فريد؛ المستلمون يرون فقط ما ترسل لهم. تتضمن ملفات PDF الموقّعة سجل تدقيق واضح يمكنك أرشفته: من وقّع، ومتى، والموافقة المعطاة، لتتسق الخصوصية والإثبات.',
  'about.teams': 'أفراد وفرق',
  'about.madeForTeams': 'مصمم للأفراد والفرق',
  'about.madeForTeamsDesc': 'قوالبنا تسهّل إنشاء المستندات، حقول التوقيع، والقوالب. معاينة PDF قبل الإرسال وإرسال لعدة مستلمين.',
  'about.sectionHeadlineBefore': 'مبني على ',
  'about.sectionHeadlineAccent': 'الثقة والسرعة',
  'about.firebaseVisualBadge': 'Google Firebase · Google Cloud',
  'faq.title': 'الأسئلة الشائعة',
  'faq.searchHint': 'ابحث بأي كلمة مفتاحية للعثور على الأسئلة الشائعة بسرعة',
  'faq.searchPlaceholder': 'مثل: PDF، قالب، توقيع...',
  'faq.noResults': 'لا توجد أسئلة شائعة تطابق بحثك. جرّب كلمات أخرى.',
  'faq.more': 'المزيد',
  'faq.less': 'أقل',
  'faq.eyebrow': 'هل لديك أسئلة؟',
  'faq.titleBefore': 'أسئلة ',
  'faq.titleAccent': 'شائعة',
  'faq.subtitleLead': 'كل ما تحتاج معرفته عن Prime Document Sign. لم تجد الإجابة؟ ',
  'faq.subtitleLink': 'تواصل معنا.',
  'faq.clearSearchAria': 'مسح البحث',
  'faq.subscriptionsWorkQ': 'كيف تعمل الاشتراكات؟',
  'faq.subscriptionsWorkA': 'نقدم خطة بريميوم (${{monthly}}/شهر أو ${{annual}}/سنة). يمكنك أيضاً الدفع per send (${{oneTimePrice}} لكل إرسال). أنشئ واعرض مجاناً؛ ادفع عند الإرسال. إدارة الخطة من حسابي → اشتراكي.',
  'faq.upgradePlanQ': 'كيف أرقّي خطتي؟',
  'faq.upgradePlanA': 'اذهب إلى حسابي → اشتراكي، اختر خطة أعلى (قياسي أو بريميوم) وأكد. الترقية سارية فوراً عادة.',
  'faq.downgradePlanQ': 'كيف أنزّل خطتي؟',
  'faq.downgradePlanA': 'حسابي → اشتراكي، اختر خطة أدنى وأكد. التنزيل يبدأ من دورة الفوترة التالية.',
  'faq.cancelPlanQ': 'كيف ألغي اشتراكي؟',
  'faq.cancelPlanA': 'حسابي → اشتراكي، ألغِ عبر بوابة Stripe أو اتصل بالدعم. الإلغاء في نهاية الدورة الحالية.',
  'faq.oneTimeOptionQ': 'ما خيار الدفع لمرة واحدة؟',
  'faq.oneTimeOptionA': 'إذا أردت الإرسال أحياناً فقط، ادفع ${{oneTimePrice}} لكل إرسال بدلاً من الاشتراك. تحصل على مزايا بريميوم لتلك الإرسالة.',
  'faq.emailLimitQ': 'ماذا عند بلوغ حد البريد الشهري؟',
  'faq.emailLimitA': 'أساسي: ٥ إيميلات/شهر، قياسي: ٥٠، بريميوم: ١٥٠. الحد يُعاد كل شهر. يمكنك شراء رصيد إضافي أو ترقية الخطّة.',
  'faq.yearlyBillingQ': 'هل يوجد فوترة سنوية؟',
  'faq.yearlyBillingA': 'نعم. بريميوم: ${{monthly}}/شهر أو ${{annual}}/سنة. السنوي يوفر حتى {{discountPercent}}٪.',
  'faq.multipleRecipientsQ': 'هل أستطيع الإرسال لعدة مستلمين؟',
  'faq.multipleRecipientsA': 'نعم. أساسي حتى ٥ مستلمين؛ قياسي وبريميوم حتى ١٠. أدخل الإيميلات مفصولة بفواصل. لا يحتاج المستلم حساباً.',
  'faq.reuseTemplatesQ': 'هل أستطيع إعادة استخدام القوالب؟',
  'faq.reuseTemplatesA': 'أساسي: ٣ قوالب، قياسي: ١٠، بريميوم: ٢٥. استخدم سجل القوالب (حسابي) لتحميلها.',
  'faq.recipientAccountQ': 'هل يحتاج المستلم حساباً؟',
  'faq.recipientAccountA': 'لا. المستلم يستلم الرابط ويمكنه التوقيع من جهازه. بدون حساب.',
  'faq.confirmationEmailQ': 'هل أستلم بريد تأكيد؟',
  'faq.confirmationEmailA': 'نعم. عند إكمال المستند يُرسل لك بريد تلقائي مع PDF الموقّع وسجل التدقيق.',
  'faq.previewPdfQ': 'هل أستطيع معاينة PDF قبل الإرسال؟',
  'faq.previewPdfA': 'نعم. استخدم زر معاينة PDF لرؤية التخطيط قبل الإرسال.',
  'faq.editAgreementQ': 'هل أستطيع تحرير نص الاتفاقية؟',
  'faq.editAgreementA': 'نعم. استخدم محرر النص لإضافة عناوين وقوائم وتنسيق. يمكنك أيضاً رفع PDF لاستخراج النص.',
  'faq.signatureRequiredQ': 'هل التوقيع إلزامي؟',
  'faq.signatureRequiredA': 'نعم. على المستلم إكمال التاريخ والاسم والشروط والتوقيع قبل الإرسال.',
  'faq.attachmentsQ': 'كم مرفقاً يمكن إرفاقه؟',
  'faq.attachmentsA': 'أساسي: لا مرفقات. قياسي: ٣ (٨ ميجا). بريميوم: ١٠ (٨ ميجا).',
  'faq.emailActivityQ': 'ما نشاط البريد (بريميوم)؟',
  'faq.emailActivityA': 'بريميوم يتضمن نشاط البريد من حسابي: أي مستندات أُرسلت ومتى ولمن.',
  'faq.emailRemindersQ': 'كيف تعمل تذكيرات البريد الإلكتروني؟',
  'faq.emailRemindersA': 'في منشئ المستندات، الخطوة ٤ (ميزات إضافية)، يمكنك تشغيل تذكيرات بعد ١ أو ٣ و/أو ٧ أيام لكل إرسال. بعد أول بريد توقيع، نرسل تذكيراً فقط إذا لم يُكمل ذلك المستلم المستند بعد. تتوقف التذكيرات تلقائياً عند التوقيع. تُدرَج رسائل التذكير في نشاط البريد مع التاريخ والوقت؛ ولا تُحتسب ضمن حد إرسال البريد الشهري.',
  'faq.defaultSenderQ': 'هل أستطيع تعيين بريد المرسل الافتراضي؟',
  'faq.defaultSenderA': 'نعم. حسابي → تفاصيل الحساب، أدخل البريد واحفظ. سيُملأ تلقائياً عند الإرسال.',
  'faq.mobileSignQ': 'هل يمكن التوقيع من الجوال؟',
  'faq.mobileSignA': 'نعم. التجربة متجاوبة. افتح الرابط على الجوال أو التابلت ووقّع بالإصبع أو القلم.',
  'faq.getHelpQ': 'كيف أحصل على مساعدة؟',
  'faq.getHelpA': 'استخدم دعم الجهات في حسابي أو نموذج اتصل بنا. نرد بأسرع ما يمكن.',
  'faq.dataSecureQ': 'هل بياناتي آمنة؟',
  'faq.dataSecureA': 'نعم. نستخدم ممارسات معيارية لحماية المستندات والمعلومات.',
  'faq.fileFormatsQ': 'ما صيغ الملفات المدعومة؟',
  'faq.fileFormatsA': 'المستندات تُنشأ في محرر النص. الاتفاقيات المكتملة تُولّد كـ PDF.',
  'faq.deleteTemplateQ': 'ماذا إن حذفت قالباً؟',
  'faq.deleteTemplateA': 'القوالب المحذوفة تُزال نهائياً. تأكد أنك لا تحتاجها قبل الحذف. يمكنك إنشاء قالب جديد من مستندك الحالي.',
  'faq.ownLogoQ': 'هل أستطيع إضافة شعاري؟',
  'faq.ownLogoA': 'نعم، في خطط قياسي وبريميوم. ارفع الشعار (حتى ٢٠ ك.ب) واختر موضعه. الأساسي لا يتضمن ذلك.',
  'faq.uploadPdfQ': 'كيف أرفع ملف PDF؟',
  'faq.uploadPdfA': 'في منشئ المستندات، استخدم خيار رفع PDF (خطط قياسي وبريميوم). يظهر ملفك فوق أو بجانب نص الاتفاقية. المستلمون يرون المستند كاملاً عند التوقيع.',
  'faq.extractPdfQ': 'ما استخراج PDF وكيف يعمل؟',
  'faq.extractPdfA': 'استخراج PDF (قياسي وبريميوم) يسمح بسحب النص من PDF موجود إلى المحرر للتعديل. ارفع PDF، اختر استخراج النص، ويُنسخ المحتوى. ثم عدّل وأضف حقول التوقيع.',
  'faq.richTextEditorQ': 'ماذا أفعل بمحرر النص الغني؟',
  'faq.richTextEditorA': 'المحرر يتيح إنشاء وتنسيق الاتفاقيات: عناوين، عريض، مائل، قوائم، أحجام خط. أضف كتل التوقيع أدناه. كل شيء بنقرة، بدون برمجة.',
  'faq.previewWhenQ': 'متى أُعاين قبل الإرسال؟',
  'faq.previewWhenA': 'استخدم دائماً معاينة PDF قبل الإرسال. تعرض التخطيط الدقيق: النص، كتل التوقيع، التاريخ، الاسم. راجع التنسيق ثم أرسل أو انسخ الرابط.',
  'faq.documentLifetimeQ': 'كم تدوم روابط التوقيع؟ هل يمكن طلب تمديد؟',
  'faq.documentLifetimeA': 'الروابط تبقى نشطة نحو ٣٠ يوماً. حمّل واحفظ PDF الموقّع قبل انتهاء الرابط. إن انتهى الرابط، تواصل مع المرسل لطلب بريد جديد برابط جديد.',
  'faq.editLayoutQ': 'كيف أعدّل تخطيط التوقيع؟',
  'faq.editLayoutA': 'استخدم تعديل التخطيط في قسم التوقيع لإعادة ترتيب الحقول. اسحب التاريخ، الاسم الكامل، الشروط، كتل التوقيع والحقول المخصصة. أضف مسافات واختر عدد الأعمدة.',
  'faq.customFieldsQ': 'كيف أضيف حقولاً مخصصة (نص، تاريخ، خانة اختيار، إلخ)؟',
  'faq.customFieldsA': 'انقر إضافة حقل مخصص في قسم التوقيع. اختر التسمية والنوع: نص، رقم، تاريخ، وقت، قائمة، خانة اختيار أو توقيع. حتى ١٠ حقول لكل مستند. حدد من يرى كل حقل ثم عدّل التخطيط.',
  'faq.multipleSignaturesQ': 'هل أستطيع إضافة توقيعين أو أكثر (عدة موقعين)؟',
  'faq.multipleSignaturesA': 'نعم. استخدم قسم المستلمين لإضافة موقع ثانٍ. كل واحد يحصل على رابط فريد وكتلة توقيع خاصة. أساسي: حتى ٥؛ قياسي وبريميوم: حتى ١٠ مستلمين لكل إرسال.',
  'faq.documentBuilderTipsQ': 'ماذا أفعل في منشئ المستندات؟',
  'faq.documentBuilderTipsA': 'إنشاء اتفاقيات، رفع أو استخراج PDF، إضافة كتل توقيع وحقول مخصصة ومرفقات. تعديل التخطيط، حفظ قوالب، معاينة PDF. التغييرات تُحفظ تلقائياً.',
  'faq.clearEverythingQ': 'ماذا يفعل مسح الكل؟',
  'faq.clearEverythingA': 'مسح الكل يعيد ضبط المنشئ: النص، كتل التوقيع، الحقول المخصصة والمرفقات. استخدمه للبدء من جديد. القوالب المحفوظة لا تتأثر.',
  'faq.forgotPasswordQ': 'نسيت كلمة المرور. كيف أعيد تعيينها؟',
  'faq.forgotPasswordA': 'في شاشة تسجيل الدخول: نسيت كلمة المرور؟ أدخل بريدك وأرسل رابط إعادة التعيين. تحقق من صندوق الوارد والرسائل غير المرغوب فيها. الرابط ينتهي—اطلب رابطاً جديداً إن لزم. سجّل الدخول بكلمة المرور الجديدة.',
  'faq.saveTemplateQ': 'كيف أحفظ المستند كقالب؟',
  'faq.saveTemplateA': 'أنشئ المستند ثم انقر حفظ القالب. أعطه اسماً واحفظ كجديد. يظهر في سجل القوالب (حسابي). للتحديث: حمّل القالب، عدّل، ثم حفظ القالب → تحديث القالب.',
  'faq.loadTemplateQ': 'كيف أحمّل قالباً من السجل؟',
  'faq.loadTemplateA': 'حسابي → سجل القوالب. انقر على القالب المطلوب. يفتح في المنشئ بالمحتوى والتخطيط الكامل. عدّل إن لزم، أضف المستلمين وأرسل.',
  'faq.templateLimitsQ': 'كم قالباً يمكنني حفظه؟',
  'faq.templateLimitsA': 'أساسي: ٣، قياسي: ١٠، بريميوم: ٢٥ قالباً. كل قالب يحفظ النص والتنسيق وكتل التوقيع والتخطيط. عند الوصول للحد: احذف قديماً أو حدّث خطتك.',
  'faq.recipientNoEmailQ': 'المستلم لم يستلم بريد التوقيع؟',
  'faq.recipientNoEmailA': 'اطلب منه التحقق من الرسائل غير المرغوب فيها. استخدم نسخ الرابط للحصول على الرابط ومشاركته يدوياً (رسالة، Slack، إلخ). أو أعد إرسال المستند لنفس البريد لرابط جديد.',
  'faq.editAfterSendQ': 'هل يمكنني تعديل المستند بعد إرساله؟',
  'faq.editAfterSendA': 'لا. بعد الإرسال يُقفل المحتوى. للتعديل: أنشئ مستنداً جديداً بالتحديثات وأعد الإرسال. المسودات غير المرسلة قابلة للتعديل بحرية.',
  'faq.changeAccountQ': 'كيف أغير بريدي أو كلمة مروري؟',
  'faq.changeAccountA': 'حسابي → تفاصيل الحساب. حدّث البريد أو كلمة المرور. لكلمة المرور: أدخل الحالية ثم الجديدة. استخدم نسيت كلمة المرور؟ إن لم تتذكر الحالية.',
  'faq.browserSupportQ': 'ما المتصفحات والأجهزة المدعومة؟',
  'faq.browserSupportA': 'Chrome، Firefox، Safari، Edge (سطح المكتب والجوال). التوقيع متجاوب—يعمل على الهواتف والأجهزة اللوحية. استخدم أحدث إصدارات المتصفح. لا حاجة لتحميل تطبيق.',
  'faq.copyLinkQ': 'كيف أنسخ رابطاً للمشاركة بدلاً من الإرسال بالبريد؟',
  'faq.copyLinkA': 'بعد إنشاء المستند انقر نسخ الرابط. يُنسخ الرابط. الصقه في رسالة أو بريد أو Slack. المستلم يمكنه التوقيع دون استلام بريد منا.',
  'faq.resendDocumentQ': 'هل يمكنني إعادة إرسال المستند إن لم يوقّع المستلم بعد؟',
  'faq.resendDocumentA': 'نعم. أعد إرسال نفس المستند لنفس البريد أو غيره. كل إرسال ينشئ رابطاً جديداً. إن انتهى الرابط الأصلي، إعادة الإرسال تعطي رابطاً جديداً. استخدم نشاط البريد (بريميوم) لتتبع الإرسالات.',
  'testimonials.eyebrow': 'آراء العملاء',
  'testimonials.title': 'ماذا يقول عملاؤنا.',
  'testimonials.quote1': 'التكلفة مناسبة جداً. قارنت عدة أدوات وPrime Document Sign كانت الأفضل قيمة وسهلة الاستخدام.',
  'testimonials.quote2': 'نسخت اتفاقية وحررتها في دقائق وأرسلتها للتوقيع. انتهيت في أقل من ١٠ دقائق.',
  'testimonials.quote3': 'قمت بكل شيء من جوالي. أنشأت المستند وأضفت حقول التوقيع وأرسلته. مريح جداً.',
  'testimonials.quote4': 'سهل الاستخدام والأسعار عادلة. فريقنا يستخدمه للعقود والاتفاقيات.',
  'testimonials.quote5': 'لصقت نص العقد وأضفت حقول التوقيع وأرسلت. وقّع المستلمون في نفس اليوم.',
  'testimonials.quote6': 'استخدمته على اللابتوب والجوال. التجربة سلسة. أفضل قيمة للتوقيع الإلكتروني.',
  'testimonials.prev': 'السابق',
  'testimonials.next': 'التالي',
  'contact.title': 'اتصل بنا',
  'contact.subtitle': 'لديك أسئلة؟ يسعدنا أن نسمع منك.',
  'contact.eyebrow': 'تواصل معنا',
  'contact.headlineBefore': 'فلن ',
  'contact.headlineAccent': 'تحدث',
  'contact.responseTimeLabel': 'زمن الاستجابة',
  'contact.responseTimeValue': 'خلال ٢٤ ساعة',
  'contact.secureLabel': 'آمن وخاص',
  'contact.secureValue': 'تشفير AES-256',
  'contact.trustNoSpam': 'لا رسائل مزعجة، أبداً',
  'contact.trustHumanSupport': 'دعم بشري حقيقي',
  'contact.firstName': 'الاسم الأول',
  'contact.lastName': 'اسم العائلة',
  'contact.email': 'البريد الإلكتروني',
  'contact.message': 'الرسالة',
  'contact.sendMessage': 'إرسال الرسالة',
  'contact.required': '*',
  'contact.placeholderFirst': 'أدخل اسمك الأول',
  'contact.placeholderLast': 'أدخل اسم العائلة',
  'contact.placeholderEmail': 'أدخل بريدك',
  'contact.placeholderMessage': 'كيف يمكننا المساعدة...',
  'contact.attachments': 'المرفقات',
  'contact.attachmentsHint': 'حتى ٥ ملفات، ٢ ميجا إجمالاً',
  'contact.addFiles': '+ إضافة ملفات',
  'contact.addAttachmentsAria': 'إضافة مرفقات',
  'auth.forgotPassword': 'نسيت كلمة المرور؟',
  'auth.backToLogIn': 'العودة لتسجيل الدخول',
  'auth.sendResetLink': 'إرسال رابط إعادة التعيين',
  'auth.checkEmailReset': 'تحقق من بريدك لرابط إعادة التعيين.',
  'auth.emailLabel': 'البريد الإلكتروني',
  'auth.passwordLabel': 'كلمة المرور',
  'auth.firstNameLabel': 'الاسم الأول',
  'auth.lastNameLabel': 'اسم العائلة',
  'auth.enterEmail': 'أدخل بريدك.',
  'auth.enterEmailPassword': 'أدخل البريد وكلمة المرور.',
  'auth.passwordMinLength': 'كلمة المرور ٨ أحرف على الأقل.',
  'auth.passwordSpecial': 'يجب أن تتضمن كلمة المرور حرفاً خاصاً.',
  'auth.passwordsNoMatch': 'كلمتا المرور غير متطابقتين.',
  'auth.signInWithGoogle': 'تسجيل الدخول بـ Google',
  'auth.or': 'أو',
  'auth.logInFailed': 'فشل تسجيل الدخول.',
  'auth.signUpFailed': 'فشل التسجيل.',
  'auth.emailAlreadyInUse': 'البريد الإلكتروني مستخدم بالفعل.',
  'connectionError.message': 'مشكلة في الاتصال. تحقق من اتصالك بالإنترنت وقم بتحديث الصفحة.',
  'connectionError.refresh': 'تحديث الصفحة',
  'connectionError.tooManyRequests': 'محاولات كثيرة. يرجى المحاولة لاحقاً.',
  'auth.emailPlaceholder': 'john@example.com',
  'auth.passwordPlaceholder': 'أدخل كلمة المرور',
  'auth.firstNamePlaceholder': 'أحمد',
  'auth.lastNamePlaceholder': 'محمد',
  'auth.manageSubscription': 'إدارة الاشتراك',
  'auth.subscribe': 'اشتراك',
  'auth.signUpForSubscription': 'التسجيل للاشتراك',
  'auth.currentPlan': 'الخطة الحالية',
  'auth.updatePlanHint': 'حدّث خطتك في Stripe للحصول على رصيد شهري أكبر.',
  'auth.updatePlanStripe': 'حدّث خطتك أو طريقة الدفع أو ألغِ من بوابة Stripe.',
  'auth.subscribeToPlan': 'اشترك في خطة للبدء.',
  'auth.topUpCredits': 'أضف رصيداً بدلاً من ذلك ({{label}}: ${{price}})',
  'pricing.featureRecipients5': 'حتى ٥ مستلمين لكل إرسال',
  'pricing.featureRecipients10': 'حتى ١٠ مستلمين لكل إرسال',
  'pricing.featureEmails5': 'حد أقصى ٥ إيميلات/شهر',
  'pricing.featureEmails50': 'حد أقصى ٥٠ إيميل/شهر',
  'pricing.featureEmails150': 'حد أقصى ١٥٠ إيميل/شهر',
  'pricing.featureTemplates3': '٣ قوالب محفوظة',
  'pricing.featureTemplates10': '١٠ قوالب محفوظة',
  'pricing.featureTemplates25': '٢٥ قالب محفوظ',
  'pricing.featureChars3k': 'حد ٣٬٠٠٠ حرف',
  'pricing.featureChars20k': 'حد ٢٠٬٠٠٠ حرف',
  'pricing.featureChars30k': 'حد ٣٠٬٠٠٠ حرف',
  'pricing.featureAttachmentsNone': 'بدون مرفقات',
  'pricing.featureAttachments3': '٣ مرفقات (٨ ميجا)',
  'pricing.featureAttachments10': '١٠ مرفقات (٨ ميجا)',
  'pricing.featurePdfUpload': 'رفع PDF كامل',
  'pricing.featureAuditTrail': 'سجل تدقيق كامل',
  'pricing.featurePdfExtract': 'استخراج وتحرير نص PDF',
  'pricing.featureCustomFields': 'إنشاء حقول مخصصة وتحرير التخطيط',
  'pricing.featureCopyLink': 'نسخ الرابط للتوقيع',
  'pricing.featureLogo': 'رفع شعار مخصص',
  'pricing.featureVerification': 'التحقق من المستلم',
  'app.createYourDocument': 'إنشاء مستندك',
  'app.backToApp': 'العودة للتطبيق',
  'app.backToMainSite': 'العودة للموقع الرئيسي',
  'app.backShort': 'رجوع',
  'app.myAccount': 'حسابي',
  'app.saveTemplate': 'حفظ القالب',
  'app.templatesUsed': 'القوالب المستخدمة',
  'app.templatesUsedSaved': '{{count}} قوالب محفوظة',
  'app.startFromTemplate': 'البدء من قالب',
  'app.startFromTemplateHint': 'اختر قالباً لملء المستند. يمكنك تعديله بعد الاختيار.',
  'app.signedInAs': 'مسجل الدخول كـ',
  'app.sendCredits': 'رصيد الإرسال',
  'app.freeSendBanner': 'لديك إرسال بريد إلكتروني مجاني واحد — استخدمه لإرسال المستند للتوقيع. يمكنك الاشتراك في أي وقت للمزيد.',
  'app.creditEqualsSend': '١ رصيد = ١ إرسال',
  'app.topUpCredits': 'إضافة رصيد',
  'app.emailSends': 'إرسالات بريد',
  'app.signedAgreements': 'اتفاقيات موقّعة',
  'app.usedAfterAllowance': '(بعد الحصة الشهرية)',
  'app.sendForSignature': 'إرسال للتوقيع',
  'app.recipientsSection': 'إرسال إلى',
  'app.fromNameOrg': 'الاسم / المنظمة',
  'app.fromNamePlaceholder': 'اسمك أو منظمتك',
  'app.fromEmail': 'البريد المرسل',
  'app.fromEmailPlaceholder': 'عنوان البريد المرسل',
  'app.recipientEmail': 'بريد المستلم',
  'app.recipientHint': 'مفصولة بفواصل، حتى {{max}} مستلم(ين)',
  'app.recipientPlaceholder': 'بريد المستلم',
  'app.recipientTooltip': 'مثال: a@b.com, c@d.com',
  'app.previewPdf': 'معاينة PDF',
  'app.clearEverything': 'مسح الكل',
  'app.clearEverythingTitle': 'مسح المستند والمستلمين والمسودة',
  'app.copyLink': 'نسخ الرابط',
  'app.copyLinkSubscribersOnly': 'نسخ الرابط (للمشتركين فقط)',
  'app.generatingLink': 'جاري إنشاء الرابط…',
  'app.sendEmail': 'إرسال البريد',
  'app.agreementText': 'نص الاتفاقية',
  'app.uploadPdfExtract': 'رفع PDF لاستخراج النص',
  'app.fullPdfUpload': 'رفع PDF كامل',
  'app.agreementPlaceholder': 'انقر هنا لبدء إنشاء نص الاتفاقية...',
  'app.attachments': 'المرفقات',
  'app.attachmentsHint': 'حتى ١٠ ملفات، ٨ ميجا كحد أقصى للتسليم بالبريد.',
  'app.addAttachment': '+ إضافة مرفق',
  'app.signatureSection': 'قسم التوقيع',
  'app.totalSignatures': 'إجمالي التوقيعات',
  'app.createNewField': 'إنشاء حقل جديد',
  'app.addField': 'إضافة حقل',
  'app.layout': 'التخطيط',
  'app.editLayout': 'تعديل التخطيط',
  'app.addFieldTooltip': 'أضف حقل مخصص (نص، تاريخ، خانة، توقيع) إلى كتلة التوقيع. حتى {{max}} حقول مخصصة.',
  'app.date': 'التاريخ',
  'app.datePlaceholder': 'yyyy/mm/dd',
  'app.termsConditions': 'الشروط والأحكام',
  'app.fullName': 'الاسم الكامل',
  'app.fullNamePlaceholder': 'أدخل الاسم الكامل',
  'app.signature': 'التوقيع',
  'app.clickToSign': 'انقر للتوقيع',
  'app.termsAgree': 'أوافق على جميع الشروط والأحكام.',
  'app.phone': 'الهاتف',
  'app.phonePlaceholder': 'أدخل رقم الهاتف',
  'app.enterFieldPlaceholder': 'أدخل {{label}}',
  'app.enterNumber': 'أدخل الرقم',
  'app.selectOption': 'اختر...',
  'app.noFields': 'لا حقول',
  'app.newDocument': 'مستند جديد',
  'app.templateLabel': 'قالب: {{name}}',
  'app.forSubscribersOnly': 'للمشتركين فقط',
  'app.emailCredits': 'رصيد البريد',
  'app.creditHintDeliver': '١ رصيد = ١ إرسال — انقر إرسال للتسليم',
  'app.skipAuthTesting': 'تخطي المصادقة (للاختبار)',
  'app.agreementRequired': 'نص الاتفاقية أو رفع PDF مطلوب.',
  'app.agreementOrPdfRequired': 'نص الاتفاقية أو مستند PDF مطلوب.',
  'app.loadingPdf': 'جاري تحميل PDF…',
  'app.clearConfirmTitle': 'مسح الكل',
  'app.clearConfirmMessage': 'هل أنت متأكد من مسح جميع الحقول والمرفقات؟',
  'app.cancel': 'إلغاء',
  'app.clear': 'مسح',
  'app.clearConfirmButton': 'نعم، مسح الكل',
  'footer.tagline': 'التوقيع الإلكتروني الآمن للمستخدمين الحديثين.',
  'footer.product': 'المنتج',
  'footer.templates': 'القوالب',
  'footer.company': 'الشركة',
  'footer.contactSupport': 'اتصل بالدعم',
  'footer.copyright': '© 2026 primedocumentsign. جميع الحقوق محفوظة.',
  'footer.terms': 'شروط الخدمة',
  'footer.privacy': 'سياسة الخصوصية',
  'auth.logIn': 'تسجيل الدخول',
  'auth.loggingIn': 'جاري تسجيل الدخول…',
  'auth.getStarted': 'ابدأ',
  'auth.signUp': 'التسجيل',
  'auth.logInToManage': 'سجّل الدخول لإدارة وإرسال المستندات للتوقيع.',
  'auth.startSending': 'ابدأ إرسال المستندات بخطة اشتراك بسيطة.',
  'auth.termsConfirmStart': 'أؤكد أنني قرأت وأوافق على',
  'auth.termsConfirmEnd': '.',
  'auth.termsMustAccept': 'يرجى قبول شروط الخدمة لإنشاء حساب.',
  'email.signSubject': 'يرجى التوقيع على هذه الاتفاقية',
  'email.signTitle': 'مستند للتوقيع',
  'email.signSubtitle': 'تم طلب توقيعك على مستند',
  'email.fromLabel': 'من',
  'email.signBody': 'انقر الزر أدناه لفتح المستند وإضافة توقيعك. أي مستلم يمكنه استخدام هذا الرابط للوصول والتوقيع — بدون حساب أو اشتراك.',
  'email.signButton': 'التوقيع على المستند',
  'email.copyLink': 'أو انسخ هذا الرابط:',
  'email.ignoreNote': 'إن لم تكن تتوقع هذا البريد يمكنك تجاهله.',
  'modal.editFieldLayout': 'تعديل تخطيط الحقول',
  'modal.editFieldLayoutHint': 'اسحب الحقول لإعادة الترتيب أو النقل بين الأعمدة.',
  'modal.columns': 'الأعمدة',
  'modal.col': '{{n}} عمود',
  'modal.addSpace': 'إضافة مسافة',
  'modal.fields': 'الحقول',
  'modal.leftColumn': 'العمود الأيسر',
  'modal.rightColumn': 'العمود الأيمن',
  'modal.removeFromLayout': 'إزالة {{name}} من التخطيط؟',
  'modal.space': 'مسافة',
  'modal.yesRemove': 'نعم، إزالة',
  'modal.keepIt': 'إبقاء',
  'modal.emptySpace': 'مسافة فارغة',
  'modal.dropFieldsHere': 'أفلت الحقول هنا',
  'modal.removedFromLayout': 'أُزيل من التخطيط — انقر + للاستعادة',
  'modal.saveLayout': 'حفظ التخطيط',
  'modal.removeFromLayoutTitle': 'إزالة من التخطيط',
  'modal.restoreToLayout': 'استعادة إلى التخطيط',
  'modal.editCustomField': 'تعديل الحقل المخصص',
  'modal.editCustomFieldHint': 'غيّر التسمية أو النوع أو من يرى هذا الحقل.',
  'modal.addCustomField': 'إضافة حقل مخصص',
  'modal.addCustomFieldHint': 'إنشاء حقل جديد للنموذج. حد أقصى ١٠ حقول مخصصة.',
  'modal.fieldLabel': 'تسمية الحقل',
  'modal.fieldLabelPlaceholder': 'مثال: اسم الشركة',
  'modal.fieldType': 'نوع الحقل',
  'modal.displayContent': 'المحتوى المعروض (للقراءة فقط، حد ١٠٠ حرف)',
  'modal.displayContentPlaceholder': 'مثال: يرجى مراجعة الشروط أدناه',
  'modal.picklistOptions': 'خيارات القائمة (حد ١٠)',
  'modal.typeAndPressAdd': 'اكتب واضغط إضافة',
  'modal.add': 'إضافة',
  'modal.addedToSignature': 'مضاف للتوقيع',
  'modal.addedToSignatureHint': 'فعّل المربعات لإضافة الحقل إلى تخطيط التوقيع',
  'modal.signature1': 'التوقيع ١',
  'modal.signature2': 'التوقيع ٢',
  'modal.close': 'إغلاق',
  'modal.save': 'حفظ',
  'modal.fieldLabelRequired': 'تسمية الحقل مطلوبة',
  'modal.displayContentRequired': 'المحتوى مطلوب لعرض النص',
  'modal.picklistOptionRequired': 'أضف خياراً واحداً على الأقل للقائمة',
  'modal.selectOneSignature': 'اختر توقيعاً واحداً على الأقل',
  'modal.signingSectionExceed': 'قسم التوقيع سيتجاوز حد {{limit}} ك.ب. أزل محتوى أولاً.',
  'modal.link': 'الرابط',
  'modal.linkTitle': 'عنوان الرابط',
  'modal.linkUrl': 'رابط URL',
  'modal.linkTextPlaceholder': 'نص الرابط',
  'modal.linkUrlPlaceholder': 'https://example.com',
  'modal.agreementSizeLimitReached': 'تم بلوغ حد حجم الاتفاقية',
  'modal.characterLimitReached': 'تم بلوغ حد الأحرف',
  'modal.agreementSizeLimitMessage': 'بلغت الحجم الأقصى للاتفاقية ({{max}} ك.ب). أزل محتوى أو صوراً قبل الإضافة.',
  'modal.characterLimitMessage': 'بلغت حد الأحرف ({{max}}). أزل نصاً قبل الإضافة.',
  'modal.signingSectionLimitReached': 'تم بلوغ حد قسم التوقيع',
  'modal.signingSectionLimitMessage': 'بلغت الحجم الأقصى لقسم التوقيع ({{limit}} ك.ب). أزل حقولاً أو توقيعات.',
  'modal.ok': 'موافق',
  'modal.addYourSignature': 'أضف توقيعك',
  'modal.signatureHint': 'استخدم الفأرة أو لوحة اللمس للتوقيع.',
  'modal.clear': 'مسح',
  'modal.saveSignature': 'حفظ التوقيع',
  'modal.removeAttachment': 'إزالة المرفق',
  'modal.removeAttachmentConfirm': 'هل تريد إزالة "{{name}}" من هذا المستند؟',
  'modal.yesRemoveLabel': 'نعم، إزالة',
  'modal.removeLogo': 'إزالة الشعار',
  'modal.removeLogoConfirm': 'هل تريد إزالة شعارك من هذا المستند؟',
  'modal.textDisplay': 'عرض النص',
  'modal.picklist': 'قائمة اختيار',
  'modal.number': 'رقم',
  'modal.time': 'الوقت',
  'modal.editLabel': 'تعديل التسمية',
  'modal.editField': 'تعديل الحقل',
  'modal.text': 'نص',
  'modal.checkbox': 'خانة اختيار',
  'modal.date': 'التاريخ',
  'modal.signature': 'التوقيع',
  'modal.typeHasDataHint': 'لا يمكن تغيير النوع لأن الحقل يحتوي بيانات.',
  'modal.typeHasDataTitle': 'لا يمكن تغيير النوع عندما يحتوي الحقل على بيانات',
  'modal.noKeepIt': 'لا، إبقاء',
  'modal.yesDelete': 'نعم، حذف',
  'modal.deleteTemplate': 'حذف القالب',
  'modal.deleteTemplateConfirm': 'هل تريد حذف "{{name}}"؟ لا يمكن التراجع.',
  'modal.removeAttachmentFromMessage': 'هل تريد إزالة "{{name}}" من رسالتك؟',
  'modal.readyToSend': 'جاهز للإرسال؟',
  'modal.recipientsLabel': 'المستلمون:',
  'modal.readyToSendSubtitle': 'هل راجعت المستند وتريد الإرسال؟ المستلمون التاليون سيستلمون هذا البريد:',
  'modal.no': 'لا',
  'modal.yesSend': 'نعم، إرسال',
  'modal.accountAlreadyExists': 'الحساب موجود مسبقاً',
  'modal.accountAlreadyExistsMessage': 'هذا البريد مسجّل. هل تريد تسجيل الدخول أم التسجيل ببريد آخر؟',
  'modal.useDifferentEmail': 'استخدام بريد آخر',
  'modal.logIn': 'تسجيل الدخول',
  'modal.logOut': 'تسجيل الخروج؟',
  'modal.logOutSubtitle': 'هل أنت متأكد من تسجيل الخروج؟',
  'modal.yesLogOut': 'نعم، تسجيل الخروج',
  'lang.ar': 'العربية',

  'templates.starter.nda.name': 'اتفاقية السرية (NDA)',
  'templates.starter.nda.scopeTitle': 'اتفاقية السرية',
  'templates.starter.freelance.name': 'اتفاقية خدمات العمل الحر',
  'templates.starter.freelance.scopeTitle': 'اتفاقية خدمات العمل الحر',
  'templates.starter.vehicle.name': 'اتفاقية بيع المركبات',
  'templates.starter.vehicle.scopeTitle': 'اتفاقية بيع المركبات',
  'templates.starter.rental.name': 'اتفاقية الإيجار السكني',
  'templates.starter.rental.scopeTitle': 'اتفاقية الإيجار السكني',
  'templates.starter.recruitment.name': 'اتفاقية خدمات التوظيف',
  'templates.starter.recruitment.scopeTitle': 'اتفاقية خدمات التوظيف',
  'templates.starter.loan.name': 'اتفاقية القرض',
  'templates.starter.loan.scopeTitle': 'اتفاقية القرض',
  'templates.starter.website.name': 'اتفاقية تطوير المواقع',
  'templates.starter.website.scopeTitle': 'اتفاقية تطوير المواقع',
  'templates.starter.roommate.name': 'اتفاقية التعايش',
  'templates.starter.roommate.scopeTitle': 'اتفاقية التعايش',
  'templates.starter.photography.name': 'اتفاقية خدمات التصوير الفوتوغرافي',
  'templates.starter.photography.scopeTitle': 'اتفاقية خدمات التصوير الفوتوغرافي',
  'templates.starter.shortterm-rental.name': 'اتفاقية الإيجار قصير الأجل',
  'templates.starter.shortterm-rental.scopeTitle': 'اتفاقية الإيجار قصير الأجل',
  'templates.starter.equipment-rental.name': 'اتفاقية تأجير المعدات',
  'templates.starter.equipment-rental.scopeTitle': 'اتفاقية تأجير المعدات',
  'templates.starter.independent-contractor.name': 'اتفاقية المقاول المستقل',
  'templates.starter.independent-contractor.scopeTitle': 'اتفاقية المقاول المستقل',
}
